import "./GlobalOperations.module.css";
import Header from "@/reusable_sections/Header";
import TheGalleryOfDigitalExcellence from "./sections/TheGalleryOfDigitalExcellence";
import OurTrustedPartners from "./sections/OurTrustedPartners";
import Footer from "@/reusable_sections/Footer";
export default function GlobalOperationsPage() {
  return <div>
      <Header />
      <TheGalleryOfDigitalExcellence />
      <OurTrustedPartners />
      <Footer />
    </div>;
}